/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_TaglineInputs */

const en_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From database to deployed UI, a complete product, not just a frontend.`)
};

const ar_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من قاعدة البيانات إلى الواجهة المُنشَّرة, منتج كامل، لا مجرد واجهة أمامية.`)
};

const bn_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেটাবেস থেকে ডিপ্লয়েড UI পর্যন্ত, শুধু ফ্রন্টএন্ড নয়, একটি সম্পূর্ণ পণ্য।`)
};

const de_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von der Datenbank bis zur bereitgestellten Benutzeroberfläche ein vollständiges Produkt, nicht nur ein Frontend.`)
};

const es_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde la base de datos hasta la UI desplegada, un producto completo, no solo un frontend.`)
};

const fr_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De la base de données à l'interface utilisateur déployée, un produit complet, pas seulement un frontend.`)
};

const pt_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do banco de dados à UI implantada, um produto completo, não apenas um frontend.`)
};

const zh_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从数据库到部署的 UI，一个完整的产品，而不仅仅是一个前端。`)
};

const tr_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veritabanından dağıtılan kullanıcı arayüzüne kadar yalnızca bir ön uç değil, eksiksiz bir ürün.`)
};

const ru_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`От базы данных до развернутого пользовательского интерфейса, полноценный продукт, а не просто интерфейс.`)
};

const pl_svc_full_stack_web_apps_tagline = /** @type {(inputs: Svc_Full_Stack_Web_Apps_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od bazy danych po wdrożony interfejs użytkownika, kompletny produkt, a nie tylko frontend.`)
};

/**
* | output |
* | --- |
* | "From database to deployed UI, a complete product, not just a frontend." |
*
* @param {Svc_Full_Stack_Web_Apps_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_tagline = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_tagline(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_tagline(inputs)
	return en_svc_full_stack_web_apps_tagline(inputs)
});
export { svc_full_stack_web_apps_tagline as "svc_full-stack-web-apps_tagline" }